const translation = {
  tab2020: '2020년',
  tab2021: '2021년',
  title: "연말정산 이용가이드",
  subText: "WEHAGO 연말정산 서비스의 기능을 확인해보세요!",
  download: "연말정산 메뉴얼 다운로드",
  enquiryRegistrationAlert: "연말정산 문의가 등록되었습니다.",
  checkInfo1: "문의자 정보를 확인해주세요.",
  replyEmail: "이메일 주소로 빠른 시간 내 답변드리겠습니다.",
  validationError: "연락처나 이메일 주소 형식이 올바르지 않습니다.",
  checkInfo2: "정보 확인 후 다시 시도해주세요.",
  ok: "확인",
  provideLater: "추후 제공 예정입니다.",
  author: "작성자",
  enterName: "성명을 입력하세요.",
  companyName: "회사명",
  enterCompanyName: "회사명을 입력하세요",
  contacts: "연락처",
  enterContacts: "연락처를 입력하세요(' - '제외)",
  email: "이메일 주소",
  enterEmail: "이메일주소를 입력하세요.",
  enquiryRegistration: "WEHAGO 연말정산 문의등록",
  enquirySubText: "연말정산 서비스에 대해 궁금하신 점을 작성해주세요.",
  InquirerInfo: "문의자정보",
  InquirerContent: "문의내용",
  enterContent: "내용을 입력하세요.",
  consentText: `정보통신망 이용촉진 및 정보보호 등에 관한 법률에 따라 연말정산 서비스의 문의사항을 처리를 위하여 다음과 같이 개인정보를 수집 및 이용하고자 하니 동의하여 주시기 바랍니다. <br/> <br/>
                수집 항목: 성명, 회사명, 휴대전화, 이메일주소<br/> 
                수집 목적: 문의 사항에 대한 답변 회신 <br/> 
                보관 기간: 문의 등록일로부터 3년까지 보관/이용 후 파기 `,
  registration: "등록",
  fullView: "전체보기",
  folding: "접기",
  postDate: "게시일",
  hitCount: "조회수",
  faq: "자주 묻는 질문",
  inquiryRegistration1: "문의등록",
  inquiryRegistration2: "문의하기",
  subTitle: "WEHAGO 연말정산",

  webpacktest: "test",

  contentsPreparingTitle: "콘텐츠 준비중입니다.",
  contentsPreparingMessage: "빠른 시일내에 오픈하겠습니다.",
};

export { translation };
